// Osano consent manager.
//
// Osano arrives via the GTM container (see docs/analytics.md §6), so it may be
// absent — blocked, still loading, or not configured for this host, as in
// localdev. Everything here is best-effort and must never throw.

interface OsanoGlobal {
  cm?: {
    showDrawer?: (drawer: string) => void;
  };
}

declare global {
  interface Window {
    Osano?: OsanoGlobal;
  }
}

/** Opens Osano's cookie preferences drawer. Returns whether Osano was available. */
export function openCookiePreferences(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const showDrawer = window.Osano?.cm?.showDrawer;
    if (!showDrawer) return false;
    showDrawer.call(window.Osano?.cm, "osano-cm-dom-info-dialog-open");
    return true;
  } catch {
    // Never throw.
    return false;
  }
}
